export const initialSdohState = {
  issues: [],
  interestedInDiscussing: undefined,
  additionalDetails: undefined,
};
